<script>
  import Info from './svgs/Info.svelte'
  import {
    storesForPickupStore as storesForPickup,
    storesForHomeDeliveryStore as storesForHomeDelivery,
    selectedZipCodeStore as selectedZipCode,
    selectedCityStore as selectedCity,
  } from '../stores'
  import { trackEvent } from "../utils/track"

  let showInfo = false

  storesForPickup.subscribe(stores => {
    if (stores.length) {
      showInfo = false
    }
  })
  storesForHomeDelivery.subscribe(stores => {
    if (stores.length) {
      showInfo = false
    }
  })
  selectedZipCode.subscribe(zip => {
    if (zip) {
      showInfo = false
    }
  })
  selectedCity.subscribe(city => {
    if (city) {
      showInfo = false
    }
  })

  const showInfoView = () => {
    trackEvent({ event: "genericStoreLogin" })
    showInfo = true
  }
</script>

<style lang="scss">
  .action {
    margin: calc(var(--spacing) * 2) 0;
    text-align: center;

    button {
      border-radius: 50px;
      background: #fff;
      line-height: 1.25;
      font-size: 14px;
      font-weight: 700;
      color: #2e2929;
      margin: 0 0 1rem;
      padding: 0 0.75rem;
      height: 2rem;
      border: 0;
      outline: 0;
    }
    p {
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 700;
      line-height: 1.25;
      color: #fff;
    }
  }

  .info {
    display: flex;
    justify-content: center;
    padding: 0 var(--spacing) var(--spacing);

    &__content {
      display: flex;
      gap: 12px;
      background: #f6f6f6;
      padding: var(--spacing);
      font-size: 14px;
      border-radius: 2px;
      max-width: 320px;

      @media screen and (--for-tablet-portrait-up) {
        padding: var(--spacing) 32px var(--spacing) var(--spacing);
        max-width: 420px;
      }

      & :global(svg) {
        min-width: 20px;
      }
    }

    &__heading {
      font-weight: 600;
      text-align: left;
    }

    &__body {
      text-align: left;

      br {
        display: none;

        @media screen and (--for-tablet-portrait-up) {
          display: block;
        }
      }
    }
  }
</style>

{#if showInfo}
  <div class="info">
    <div class="info__content">
      <Info />
      <div>
        <p class="info__heading">
          Se dina sparade butiker - kommer snart
        </p>
        <p class="info__body">
          Tack för att du testade, det hjälper oss att prioritera rätt framåt. För att handla, sök på postnummer eller ort.
        </p>
      </div>
    </div>
  </div>
{:else}
  <div class="action">
    <button on:click={showInfoView}>Logga in</button>
    <p>Logga in för att se dina sparade butiker</p>
  </div>
{/if}
